import { SIZE } from 'baseui/button'

import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import SDLoader from '@/shared/components/SDComponentsNewDesign/SDLoader/SDLoader'

import useCache from './useCache'
import { ActionsRow, FieldsColumn, NotificationsWrapper, OutputBox, Stack } from './styled-components'

const formatCacheValue = value => {
  if (value === null || value === undefined) return ''
  if (typeof value === 'string') return value
  return JSON.stringify(value, null, 2)
}

const CacheForm = () => {
  const { form, t } = useCache()

  return (
    <Stack>
      <FieldsColumn>
        <SDFormControl label={t('cache.label_input')}>
          <SDInput
            currentValue={form.cacheKey}
            outerOnchange={form.onCacheKeyChange}
            placeholder={t('cache.place_holder_input')}
            onKeyDown={event => {
              if (event.key === 'Enter') form.onSearch()
            }}
          />
        </SDFormControl>
      </FieldsColumn>

      <ActionsRow>
        <SDButton size={SIZE.compact} block={false} disabled={!form.cacheKey || form.isSearching} onClick={form.onSearch}>
          {t('cache.search_button')}
        </SDButton>
        <SDLoader hidden={!form.isSearching} text={t('common:fetching_data')} />
      </ActionsRow>

      <NotificationsWrapper>
        <SDNotification type='negative' hidden={!form.error} primaryText={String(form.error || '')} />
        <SDNotification type='positive' hidden={!form.isEmpty} primaryText={t('cache.empty_value')} />
      </NotificationsWrapper>

      <SDFormControl label={t('cache.label_output')} hidden={form.value === null}>
        <OutputBox>{formatCacheValue(form.value)}</OutputBox>
      </SDFormControl>
    </Stack>
  )
}

export default CacheForm
